import React, { Component } from 'react';
import HTML5Backend from 'react-dnd-html5-backend';
import PropTypes from 'prop-types';
import { DragDropContext } from 'react-dnd';
import './App.css';

import GalleryContainer from './components/gallery-container/GalleryContainer';
import EditorWrapper from './components/editor-wrapper/EditorWrapper';
import LayoutContainer from './components/layout-container/LayoutContainer';
import TopBarContainer from './components/top-bar/top-bar-container/TopBarContainer';
import TextTools from './components/text-tools/TextTools';
import { browserNotSupported } from './redux/helpers';
import SavebookLoader from './components/savebook-loader/savebookLoader';

class App extends Component {
  constructor(args) {
    super(...args);
  }


  render() {
    const { lang } = this.props;

    if (browserNotSupported()) {
      return (
        <div className="unsopported">
          <p>{lang.browserNotSupported}</p>
        </div>
      );
    }

    return (
      <div className="BookDesigner">
        <div className="Topbar">
          <TopBarContainer lang={lang} />
        </div>
        <div className="BookDesigner_ContentColumn">
          <div className="BookDesignerTopBar" style={{ height: '90px' }}>
            {lang.chooseModifiedText}
          </div>

          <div className="BookDesigner_MiddleWrapper">
            <div className="BookDesigner_LeftColumn  ">
              <GalleryContainer />
            </div>
            <div className="BookDesigner_MiddleColumn ">
              <EditorWrapper lang={lang} />
              <div className="textTools">
                <TextTools
                  lang={lang}
                />
              </div>
              <div className="BookDesigner_BottomBar">
                <LayoutContainer lang={lang} />
              </div>
            </div>
          </div>
        </div>
        <div className="BookDesigner_RightColumn" />
        <SavebookLoader lang={lang} />
      </div>
    );
  }
}

App.defaultProps = {
  lang: {},
};

App.propTypes = {
  lang: PropTypes.object,
};

export default DragDropContext(HTML5Backend)(App);



// WEBPACK FOOTER //
// ./src/App.jsx